<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="team"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideSearchInput="true"
      :hideAddButton="true"
      @add="goToResultPage($event.id)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import { ExamUnitTypeTranslation } from '@/enums/examUnitType.enum';
import { listMixin } from '@/mixins/list';
import { ADD_ACTION } from '@/utils/constants';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Lista egzaminów możliwych do przeprowadzenia
// @group Team
export default {
  mixins: [
    listMixin('exam', {
      listError: 'messages.exam.listError',
      getError: 'messages.exam.getError',
      added: 'messages.exam.added',
      addError: 'messages.exam.addError',
      updated: 'messages.exam.updated',
      updateError: 'messages.exam.updateError',
      deleteConfirm: 'messages.exam.deleteConfirm',
      deleted: 'messages.exam.deleted',
      deleteError: 'messages.exam.deleteError'
    })
  ],
  components: { ComponentTable },
  data() {
    return {
      columns: [
        { name: 'name', displayName: 'columns.name', sortable: true },
        { name: 'unitName', displayName: 'columns.unit', translate: true }
      ],
      actions: [
        {
          ...ADD_ACTION,
          toolTipText: 'buttons.add-score',
          permissions: ['EXAM_RESULT.ADD'],
          entityId: this.$route.params.teamId
        }
      ]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.exam.list.map(exam => ({
          ...exam,
          unitName: ExamUnitTypeTranslation[exam.unit]
        }))
    })
  },
  methods: {
    // @vuese
    // Przechodzi do strony z wynikami egzaminu
    goToResultPage(examId) {
      this.$router.push({ name: 'teamExamsResult', params: { examId } });
    }
  }
};
</script>
